import { PublicSharedApiService } from './public-shared-api.service';
import { endpoint } from './shared-api.service';
import { GetWorkerByWorkerIdParams, GetWorkerByWorkerIdResponse } from './worker-service.types';

const publicSharedApi = new PublicSharedApiService(endpoint);

export const getWorkerByWorkerId = async ({
  workerId,
  verified,
  level,
}: GetWorkerByWorkerIdParams): Promise<GetWorkerByWorkerIdResponse> => {
  return publicSharedApi.get<GetWorkerByWorkerIdResponse>({
    path: `public/worker/${workerId}`,
    params: { verified, level },
  });
};
